
import { Vue, Watch, Component, Prop } from 'vue-property-decorator';
@Component
export default class AbstractAnimated extends Vue {
  private interval: ReturnType<typeof setInterval> | null = null;

  protected displayValue = 0;

  @Prop({ default: 50 })
  private readonly step!: number;

  @Prop({ default: 0 })
  protected readonly value!: number;

  protected getNextNumber(current: number, newValue: number): number | undefined {
    if (Math.ceil(current) !== Math.ceil(newValue)) {
      let change = (newValue - current) / this.step;
      change = change >= 0 ? Math.ceil(change) : Math.floor(change);
      let result = current + change;
      if (result < 0.01) {
        result = 0;
      }
      return result;
    }
  }

  @Watch('value')
  private numberChanged() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.value === this.displayValue) {
      return;
    }
    this.interval = setInterval(() => {
      const newValue = this.getNextNumber(this.displayValue, this.value);
      if (newValue !== undefined && newValue !== null && typeof newValue === 'number') {
        this.displayValue = newValue;
      }
    }, 5);
  }

  public created(): void {
    this.displayValue = this.value;
  }
}
